var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLock(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "#484888",
    height: 24,
    viewBox: "0 96 960 960",
    width: 24,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M252.309 955.999q-29.827 0-51.067-21.241-21.241-21.24-21.241-51.067V508.309q0-29.827 21.241-51.067 21.24-21.241 51.067-21.241h47.692v-80q0-74.922 52.538-127.46Q405.078 176.003 480 176.003t127.461 52.538q52.538 52.538 52.538 127.46v80h47.692q29.827 0 51.067 21.241 21.241 21.24 21.241 51.067v375.382q0 29.827-21.241 51.067-21.24 21.241-51.067 21.241H252.309Zm227.691-190q29.154 0 49.576-20.423 20.423-20.422 20.423-49.576t-20.423-49.576Q509.154 626.001 480 626.001t-49.576 20.423Q410.001 666.846 410.001 696t20.423 49.576q20.422 20.423 49.576 20.423ZM360 436.001h240v-80q0-50-35-85t-85-35q-50 0-85 35t-35 85v80Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLock);
export default __webpack_public_path__ + "static/media/lock.c238bb76fb746f20ba7a867bb550f1b4.svg";
export { ForwardRef as ReactComponent };